/**
 * EGApp - the electric guitar page: wiring hands, rig, band and takes.
 *
 * What each input does is decided HERE, in one place, whichever way it
 * arrives (mouse, touch, computer keyboard, MIDI): every path ends in
 * engine.play(event) with the same vocabulary as the riffs, so a take
 * records a keyboard solo and a touch chug the same way, and the export
 * re-renders both through the same rig.
 */
(function () {
    'use strict';

    var SLUG = 'electric-guitar';
    var T = window.EG_T || {};
    var CFG = window.EG_CFG || {};
    function $(id) { return document.getElementById(id); }
    function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
    function tr(k, rep) {
        var s = T[k] || k;
        if (rep) for (var r in rep) s = s.split(':' + r).join(rep[r]);
        return s;
    }
    function ae(f, d) { try { if (window.__ae) window.__ae('feature_use', Object.assign({ f: f }, d || {})); } catch (e) {} }
    function aeErr(o) { try { if (window.__aeToolError) window.__aeToolError(Object.assign({ slug: SLUG }, o)); } catch (e) {} }
    function settings() { return window.__toolSettings || null; }
    function load(key, def) { try { var s = settings(); return s ? s.load(SLUG, key, def) : def; } catch (e) { return def; } }
    function save(key, v) { try { var s = settings(); if (s) s.save(SLUG, key, v); } catch (e) {} }
    function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (e) {} }
    function stage(name, meta) { try { if (window.__stage) window.__stage(name, meta || {}); } catch (e) {} }

    function boot() {
        if (!window.EGCore || !window.EGRig || !window.EGPresets || !window.EGJam || !window.EGEngine || !window.EGUI) return;
        var Core = window.EGCore, P = window.EGPresets, UI = window.EGUI;
        if (T.solfege) UI.setSolfege(T.solfege.split(/\s+/));
        var engine = new window.EGEngine.Engine(CFG);

        // ───────────────────────────── state ──────────────────────────────
        var st = {
            preset: null,
            guitar: { model: 'lp', sel: 'b', tuning: 'std', capo: 0, tone: 0.85, vol: 1, pickMm: 85, sympathy: 0.35, noise: 0.6 },
            rig: null,
            jam: { bpm: 120, key: 'A', scale: 'minpent', drums: true, bass: true, metro: false, vol: 0.7 },
            padType: '5', pm: false, ring: false, harm: false, shift: false,
            kb: 'easy', tabSet: 0, tabPos: 0,
            lefty: false, labels: false, names: 'letters', autoVib: true, hum: 50,
            master: 0.8, started: false, firstSound: false, t0: performance.now()
        };
        /* ── telemetry: a funnel and one summary per visit, not an event per note ──
           A player sends hundreds of notes a minute, and the page's analytics queue
           holds 50 events and evicts repeats: an event per note (as this tool first
           did) crowds out the ones that matter - errors, exports - and floods the
           store. Notes, strums and seconds are summed here and sent as ONE
           `eg_session` (cumulative, with `seq`: read the last one per session) when
           the page is hidden or left, plus a checkpoint every five minutes of play. */
        var stats = { n: 0, strums: 0, bends: 0, slides: 0, hammers: 0, pm: 0, harm: 0, gsw: 0, genres: {}, tweaks: 0,
            riffs: 0, takes: 0, input: 0, playMode: 0, playModeS: 0, playS: 0, jamS: 0, longTasks: 0, tabs: 0, posN: 0 };
        var viaCount = {}, strumVia = {}, exportsBy = {};
        var statSeq = 0, statDirty = false, lastSoundAt = 0, jamSince = 0;
        function bump(o, k) { o[k] = (o[k] || 0) + 1; statDirty = true; }
        function heard() {
            var now = performance.now();
            if (lastSoundAt && now - lastSoundAt < 4000) stats.playS += (now - lastSoundAt) / 1000;
            lastSoundAt = now; statDirty = true;
        }
        function sendSummary(why) {
            if (!statDirty && why !== 'leave') return;
            if (!stats.n && !stats.strums && !stats.riffs && !jamSince && !stats.jamS) return;
            statDirty = false;
            var d = {
                seq: ++statSeq, why: why, preset: st.preset && st.preset.id,
                n: stats.n, strums: stats.strums, bends: stats.bends, slides: stats.slides, hammers: stats.hammers,
                pm: stats.pm, harm: stats.harm, genres: Object.keys(stats.genres).length, gsw: stats.gsw,
                tweaks: stats.tweaks, tabs: stats.tabs, riffs: stats.riffs, takes: stats.takes, input: stats.input,
                play_s: Math.round(stats.playS), jam_s: Math.round(stats.jamS + (jamSince ? (performance.now() - jamSince) / 1000 : 0)),
                pmode: stats.playMode, pmode_s: Math.round(stats.playModeS + (stageSince ? (performance.now() - stageSince) / 1000 : 0)),
                lt: stats.longTasks, fb: engine.fallback ? 1 : 0, kb: rootEl && rootEl.classList.contains('has-kb') ? 1 : 0,
                touch: isTouch ? 1 : 0, vw: window.innerWidth, land: window.innerWidth > window.innerHeight ? 1 : 0,
                // moves of the neck position slider, and knob turns by axis: on a 320 px phone the
                // slider is the only way up the neck, and until 01.10 a finger could barely grab it
                pos_n: stats.posN, knob_x: UI.Knob.drags ? UI.Knob.drags.x : 0, knob_y: UI.Knob.drags ? UI.Knob.drags.y : 0
            };
            for (var k in viaCount) d['v_' + k] = viaCount[k];
            for (var k2 in strumVia) d['s_' + k2] = strumVia[k2];
            for (var k3 in exportsBy) d['x_' + k3] = exportsBy[k3];
            ae('eg_session', d);
        }
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') sendSummary('hidden'); });
        window.addEventListener('pagehide', function () { sendSummary('leave'); });
        setInterval(function () { sendSummary('tick'); }, 300000);
        // main-thread stalls while playing: what makes notes arrive late (Chromium only)
        try {
            new PerformanceObserver(function (list) { if (st.started) stats.longTasks += list.getEntries().length; }).observe({ entryTypes: ['longtask'] });
        } catch (e) {}
        var isTouch = !!(window.matchMedia && window.matchMedia('(hover:none) and (pointer:coarse)').matches);

        var saved = load('prefs', null);
        if (saved && typeof saved === 'object') {
            ['lefty', 'labels', 'names', 'autoVib', 'hum', 'kb', 'padType', 'master'].forEach(function (k) { if (saved[k] !== undefined) st[k] = saved[k]; });
            if (saved.noise !== undefined) st.guitar.noise = saved.noise;
        }
        function savePrefs() {
            save('prefs', { lefty: st.lefty, labels: st.labels, names: st.names, autoVib: st.autoVib, hum: st.hum, kb: st.kb, padType: st.padType, master: st.master, noise: st.guitar.noise });
        }

        // ───────────────────────────── neck ───────────────────────────────
        var neck = new UI.Neck($('eg-neck'), {
            onPos: function (p) { $('eg-pos').value = p; },
            onRender: function () {
                var g = neck.geo;
                var pw = $('eg-poswrap');
                if (pw) pw.hidden = (g.b - g.a) >= neck.frets - 1 && g.a === 0;
            }
        });
        function tuningArr() { return (Core.TUNINGS[st.guitar.tuning] || Core.TUNINGS.std).slice(); }
        function modelDef() { return Core.MODELS[st.guitar.model] || Core.MODELS.s; }
        function syncNeck() {
            var m = modelDef(), tun = tuningArr();
            neck.set({ strings: tun.length, frets: m.frets, tuning: tun, capo: st.guitar.capo, model: st.guitar.model, lefty: st.lefty, labels: st.labels, nameStyle: st.names });
            $('eg-pos').max = Math.max(0, m.frets - 4);
        }

        // ───────────────────────────── start ──────────────────────────────
        var veil = $('eg-veil');
        var startPromise = null;
        /* iPhone audio session (silent switch, guitar input) belongs to
           ios-audio-unmute.js: it arms on the AudioContext, takes
           'play-and-record' for the input and keeps it after. The tool's own
           'playback' after closing the input was v2's shape — the NEXT input
           request was refused («AudioSession category is not compatible with
           audio capture», 23.10.2026). */
        function start() {
            if (startPromise) return startPromise;
            startPromise = engine.start().then(function () {
                st.started = true;
                veil.hidden = true;
                engine.setGuitar(st.guitar);
                engine.setNoise(st.guitar.noise, st.hum);
                engine.applyRig(st.rig);
                engine.master.gain.value = st.master;
                engine.jamBus.gain.value = st.jam.vol;
                if (engine.fallback) showMsg(T.engine_fallback, 'warn');
                var lat = engine.latencyMs();
                if (lat) $('eg-latency').textContent = tr('latency_note', { ms: lat });
                ae('eg_ready', { fallback: engine.fallback ? 1 : 0, lat: lat, sr: engine.ctx.sampleRate });
                stage('ready', { fallback: engine.fallback ? 1 : 0 });
                meterLoop();
                return engine;
            }).catch(function (e) {
                startPromise = null;
                showMsg(T.audio_failed, 'warn');
                aeErr({ error_type: 'eg_start_failed', err_msg: String(e && e.message || e).slice(0, 160) });
                throw e;
            });
            return startPromise;
        }
        function withAudio(fn) {
            if (!st.gestureAt) { st.gestureAt = performance.now(); st.prepAt = engine.prepared(); }
            // the notes fn plays carry the moment of THIS gesture, not of the engine's start
            var asked = performance.now(), c0 = engine.ctx || (engine._prep && engine._prep.ctx);
            var warm = !!c0 && c0.state === 'running';
            function run() { engine.askedAt = asked; engine.askedWarm = warm; try { fn(); } finally { engine.askedAt = 0; } }
            if (st.started) { engine.wake().then(run); return; }
            start().then(run, function () {});
        }
        // the veil is a hint over the neck, not a wall: the touch goes through to
        // the string under it, which starts the sound AND plays that string
        $('eg-neckwrap').addEventListener('pointerdown', function () { veil.hidden = true; }, true);

        /* Built before the first touch (engine.prepare): when the instrument
           is on screen or about to be, in idle time - creating the context
           alone is 0.1-0.4 s of main thread, so never inside a hover or a
           touch. Watched is the whole tool, not the neck: on a phone the neck
           sits below the first screen, and a person who scrolls straight to it
           and touches a string landed in the middle of the build (0.46 s of
           input delay at 4x CPU). A page opened in a background tab waits
           until it is looked at. */
        (function () {
            var asked = false;
            function go(why) {
                if (asked || startPromise || st.started) return;
                if (document.visibilityState !== 'visible') {
                    document.addEventListener('visibilitychange', function again() {
                        if (document.visibilityState !== 'visible') return;
                        document.removeEventListener('visibilitychange', again);
                        go(why);
                    });
                    return;
                }
                asked = true;
                var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 2000 }); } : function (f) { setTimeout(f, 200); };
                idle(function () { if (!startPromise && !st.started) { st.prepWhy = why; engine.prepare(); } });
            }
            var tool = $('eg-root');
            if (window.IntersectionObserver && tool) {
                var io = new IntersectionObserver(function (es) {
                    for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { io.disconnect(); go('tool'); return; }
                }, { rootMargin: '0px 0px 400px 0px' });
                io.observe(tool);
            } else go('load');
            var root = $('eg-root');
            if (root) {
                root.addEventListener('pointerover', function () { go('hover'); }, { once: true, passive: true });
                root.addEventListener('focusin', function () { go('focus'); }, { once: true });
            }
        })();
        engine.on('prepared', function (r) { ae('eg_prepared', { ms: r.ms, state: r.state, why: st.prepWhy || '' }); });
        engine.on('held', function (r) { st.heldNotes = r.n; });
        /* the audio device was lost and everything was rebuilt on a new context:
           the person's levels, the band (if it was playing) and the real-guitar input
           come back as they were */
        engine.on('rebuilt', function () {
            if (engine.master) engine.master.gain.value = st.master;
            if (engine.jamBus) engine.jamBus.gain.value = st.jam.vol;
            if (jamOn && engine.jam) {
                engine.jam.drumsOn = st.jam.drums; engine.jam.bassOn = st.jam.bass; engine.jam.metronome = st.jam.metro;
                engine.jam.start(jamState());
            }
            if (engine.input) { engine.closeInput(); openInput($('eg-in-dev').value || null); }
            ae('eg_rebuilt', { jam: jamOn ? 1 : 0 });
        });
        /* A touch screen may give the permission to play only on the LIFT
           (the HTML rule for touch: pointerup/touchend). The first touch then
           starts on a context the browser keeps suspended; the lift resumes it
           and the notes of that touch play with their own spacing.
           Any earlier gesture on the page (a genre, a tab) already wakes the
           prepared context - timbrica-core resumes every context on click - and
           so pays the output device's start (0.26-1.5 s measured on Windows)
           before the first note; the session stays 'ambient' until start(), so
           an iPhone keeps the person's own music playing until they play. */
        ['pointerup', 'touchend', 'click', 'keydown'].forEach(function (ev) {
            document.addEventListener(ev, function () { if (startPromise || st.started) engine.unlock(); }, { capture: true, passive: true });
        });
        engine.on('asset', function (r) {
            // a cabinet or a drum sample that did not load: the tool still plays, a part of it is missing
            if (r.failed) aeErr({ error_type: 'eg_asset_failed', kind: r.kind, failed: r.failed, why: r.why || '' });
            else ae('eg_asset_fallback', r);
        });
        engine.on('sound', function () {
            if (st.firstSound) return;
            st.firstSound = true;
            /* lat_ms - from the gesture of the first NOTE to sound, the engine's start included
               when the note waited for it (what the player hears as delay);
               wait_ms - from the first gesture of any kind (a genre click counts, so it also
               holds the time before the person played at all: 3.9 s in the first real session) */
            ae('eg_first_sound', { ms: Math.round(performance.now() - st.t0), wait_ms: st.gestureAt ? Math.round(performance.now() - st.gestureAt) : null,
                lat_ms: engine.firstPlayAt ? Math.round(performance.now() - engine.firstPlayAt) : null,
                warm: engine.firstPlayWarm ? 1 : 0,
                via: st.lastInput || 'unknown', preset: st.preset && st.preset.id, fb: engine.fallback ? 1 : 0,
                prep: st.prepAt || 'none', held: st.heldNotes || 0 });
            stage('playing', { via: st.lastInput || 'unknown' });
        });

        /* The tool's status line. In play mode the instrument is the browser's
           fullscreen element - the top layer - and everything outside it,
           the page's own line and the site's toasts included, is not drawn:
           "could not start the sound" said there was said to nobody. Play mode
           has a line of its own, and what is on screen moves with the person. */
        var stageMsg = null;
        function showMsg(text, kind) {
            var m = stageMsg || $('eg-msg');
            if (!text) { m.hidden = true; return; }
            m.textContent = text; m.className = 'eg-msg' + (kind ? ' ' + kind : ''); m.hidden = false;
        }

        // ─────────────────────────── playing notes ────────────────────────
        function vib(s, on) { engine.play({ type: 'vib', s: s, depth: on ? 0.22 : 0, rate: 5.4 }); }
        function noteOpts(fret, extra) {
            var o = {};
            if (st.pm || st.shift) o.pm = 0.85;
            if (st.harm) {
                var nh = { 12: 2, 24: 2, 7: 3, 19: 3, 5: 4, 4: 5, 9: 5, 16: 5 };
                if (nh[fret]) o.harm = nh[fret]; else o.pinch = true;
            }
            return Object.assign(o, extra || {});
        }
        /*
         * What the fretting hand does between notes. A keyboard, a mouse and a
         * touch screen cannot tell "pluck and let it ring" from "hold, then let
         * go", so the length of the press decides: a TAP rings on like a picked
         * string, a HOLD stops when released. A new note or chord then stops
         * whatever it does not use, as a guitarist's hand does - otherwise taps
         * pile up into a high-gain mud. 'Let ring' switches all stopping off.
         * Measured: a scripted key press lasts ~5 ms and a human tap 70-150 ms;
         * when every release muted, taps were 0.1 s blips and the AudioSet
         * tagger heard a heavy-metal take as "Vehicle horn" (0.72), not a guitar.
         * MIDI keeps note-off semantics: a keyboardist sets lengths by hand.
         */
        var TAP_MS = 260;
        var sounding = {};          // string -> true while a gesture may have left it ringing
        var padHeld = {};           // pad index -> true while a pointer holds it
        function heldBy(s, withPads) {
            for (var c in keyDown) {
                var k = keyDown[c];
                if (!k || k === true) continue;
                if (k.s === s) return true;
                if (withPads && k.pad !== undefined && pads[k.pad] && pads[k.pad].frets && pads[k.pad].frets[s] >= 0) return true;
            }
            for (var id in touches) if (touches[id] && touches[id].s === s) return true;
            if (withPads) for (var i in padHeld) if (padHeld[i] && pads[i] && pads[i].frets && pads[i].frets[s] >= 0) return true;
            return false;
        }
        function quiet(keep, withPads) {
            if (st.ring) return;
            var list = [];
            for (var k in sounding) {
                var s = +k;
                if (keep[s] || heldBy(s, withPads)) continue;
                list.push({ type: 'off', s: s, rel: 0.05 });
                delete sounding[k];
            }
            if (list.length) engine.play(list);
        }
        function lift(s, heldMs) {
            if (st.ring || heldMs < TAP_MS) return;
            engine.play({ type: 'off', s: s, rel: 0.08 });
            delete sounding[s];
        }
        /* A single note on (string, fret); the neck shows it. */
        function pluck(s, fret, vel, extra, via) {
            st.lastInput = via || st.lastInput;
            if (via !== 'midi') { var keep = {}; keep[s] = 1; quiet(keep, true); }
            sounding[s] = true;
            var o = noteOpts(fret, extra);
            var f = o.harm ? 0 : fret;
            if (o.harm) o.harm = o.harm;      // natural harmonic sounds the open string's partial
            engine.play({ type: 'on', s: s, fret: o.harm ? 0 : fret, vel: vel || 0.8, o: o });
            neck.hit(s, fret);
            lastSingle = { s: s, fret: f, t: performance.now() };
            stats.n++; bump(viaCount, via || 'neck'); heard();
            if (o.pm) stats.pm++;
            if (o.harm || o.pinch) stats.harm++;
        }
        function release(s) { if (!st.ring) { engine.play({ type: 'off', s: s, rel: 0.08 }); delete sounding[s]; } }
        var lastSingle = null, lastChord = null;

        // ─────────────────────────── chord voicings ───────────────────────
        var CHORD_IV = { '5': [0, 7], '': [0, 4, 7], 'm': [0, 3, 7], 'dim': [0, 3, 6], 'aug': [0, 4, 8], '7': [0, 4, 7, 10], 'm7': [0, 3, 7, 10], '9': [0, 4, 7, 10, 2], 'm9': [0, 3, 7, 10, 2] };
        /*
         * Voice a chord on THIS tuning: search a 4-fret window for a shape
         * whose lowest string is the root and that holds the chord's tones,
         * preferring low positions, full chords and no stretch. Works for
         * drop, open and seven-string tunings where the textbook barre shapes
         * do not exist.
         */
        function voice(rootPc, q, maxStrings) {
            var tun = tuningArr(), n = tun.length, capo = st.guitar.capo;
            var iv = CHORD_IV[q] || CHORD_IV[''];
            var pcs = iv.map(function (i) { return (rootPc + i) % 12; });
            var best = null;
            for (var p = 0; p <= 10; p++) {
                for (var low = n - 1; low >= Math.max(2, n - 3); low--) {
                    var fRoot = -1;
                    for (var f = (p === 0 ? 0 : p); f <= p + 3; f++) if ((tun[low] + capo + f) % 12 === rootPc) { fRoot = f; break; }
                    if (fRoot < 0) continue;
                    var frets = []; for (var z = 0; z < n; z++) frets.push(-1);
                    frets[low] = fRoot;
                    var have = {}; have[rootPc] = 1;
                    var used = 1;
                    if (q === '5') {
                        // root, fifth, octave: by pitch, adjacent strings
                        var r = tun[low] + capo + fRoot;
                        var f5 = r + 7 - (tun[low - 1] + capo), f8 = r + 12 - (tun[low - 2] + capo);
                        if (f5 < 0 || f5 > 22) continue;
                        frets[low - 1] = f5;
                        if (f8 >= 0 && f8 <= 22 && Math.abs(f8 - fRoot) <= 3) frets[low - 2] = f8;
                        var sc = fRoot + (frets[low - 2] >= 0 ? 0 : 1);
                        if (!best || sc < best.sc) best = { frets: frets, sc: sc };
                        continue;
                    }
                    for (var s2 = low - 1; s2 >= 0; s2--) {
                        var pick = -1;
                        for (var f2 = (p === 0 ? 0 : p); f2 <= p + 3; f2++) {
                            var pc = (tun[s2] + capo + f2) % 12;
                            if (pcs.indexOf(pc) >= 0) { if (pick < 0 || (!have[pc] && have[(tun[s2] + capo + pick) % 12])) pick = f2; }
                        }
                        if (pick >= 0) { frets[s2] = pick; have[(tun[s2] + capo + pick) % 12] = 1; used++; }
                        if (maxStrings && used >= maxStrings) break;
                    }
                    var missing = pcs.filter(function (x) { return !have[x]; }).length;
                    var span = 0, mn = 99, mx = -1;
                    frets.forEach(function (fv) { if (fv > 0) { mn = Math.min(mn, fv); mx = Math.max(mx, fv); } });
                    if (mx >= 0) span = mx - mn;
                    var score = missing * 10 + (n - used) * 1.5 + span * 0.6 + p * 0.35 + (low === n - 1 ? 0 : 0.8);
                    if (!best || score < best.sc) best = { frets: frets, sc: score };
                }
            }
            return best ? best.frets : null;
        }

        var pads = [];
        var lastPad = 0, padDir = {};
        /* Which chords and how they are named is music theory and lives in
           EGPresets.padChords (tested in node); here they get a shape on THIS
           guitar's tuning and capo. */
        var PAD_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8'];
        function padChords() {
            return P.padChords(st.jam.key, st.jam.scale, st.preset.jam.prog, st.padType === '5' ? '5' : 'full', PAD_KEYS.length)
                .map(function (c) { c.frets = voice(c.rootPc, CHORD_IV[c.q] ? c.q : ''); return c; });
        }
        function renderPads() {
            var host = $('eg-pads');
            pads = padChords();
            // the same buttons for every key and genre: only the chords on them change
            if (host.children.length === pads.length) {
                pads.forEach(function (c, i) { var b = host.children[i]; b.querySelector('.n').textContent = c.name; b.setAttribute('aria-label', c.name); });
                return;
            }
            host.innerHTML = '';
            pads.forEach(function (c, i) {
                var b = document.createElement('button');
                b.type = 'button'; b.className = 'eg-pad';
                b.innerHTML = '<span class="n"></span><span class="k eg-kbd-only"></span>';
                b.querySelector('.n').textContent = c.name;
                b.querySelector('.k').textContent = PAD_KEYS[i];
                b.setAttribute('aria-label', c.name);
                b.dataset.i = i;
                var down = null;
                b.addEventListener('pointerdown', function (e) {
                    e.preventDefault();
                    try { b.setPointerCapture(e.pointerId); } catch (x) {}
                    down = { y: e.clientY, strummed: false, since: performance.now() };
                    padHeld[i] = true;
                    st.lastInput = e.pointerType === 'touch' ? 'touch' : 'mouse';
                    withAudio(function () { strumPad(i, null); down && (down.strummed = true); });
                });
                b.addEventListener('pointermove', function (e) {
                    if (!down) return;
                    if (e.clientY - down.y < -14) { down.y = e.clientY; strumPad(i, 'u'); }
                    else if (e.clientY - down.y > 14) { down.y = e.clientY; strumPad(i, 'd'); }
                });
                function up() {
                    if (!down) return;
                    var held = performance.now() - down.since;
                    down = null; delete padHeld[i]; b.classList.remove('down');
                    if (!st.ring && held >= TAP_MS) mutePad(i);
                }
                b.addEventListener('pointerup', up);
                b.addEventListener('pointercancel', up);
                // Enter / Space on a focused pad: a tap, so the chord rings on
                b.addEventListener('click', function (e) { if (e.detail === 0) withAudio(function () { strumPad(i, null); setTimeout(function () { var el = $('eg-pads').children[i]; if (el) el.classList.remove('down'); }, 150); }); });
                host.appendChild(b);
            });
        }
        /* Strum a pad. Repeated taps alternate down/up like a real right hand. */
        function strumPad(i, dir) {
            var c = pads[i];
            if (!c || !c.frets) return;
            var now = performance.now();
            if (!dir) {
                var last = padDir[i];
                dir = (last && now - last.t < 380 && last.d === 'd') ? 'u' : 'd';
            }
            padDir[i] = { t: now, d: dir };
            lastPad = i;
            var el = $('eg-pads').children[i];
            if (el) el.classList.add('down');
            var strings = [], keep = {};
            c.frets.forEach(function (f, s) { if (f >= 0) { strings.push([s, f]); keep[s] = 1; } });
            // a new chord replaces the old shape: strings it does not use stop
            quiet(keep, false);
            strings.forEach(function (x) { sounding[x[0]] = true; });
            strings.sort(function (a, b) { return dir === 'u' ? a[0] - b[0] : b[0] - a[0]; });
            var vel = dir === 'u' ? 0.72 : 0.86;
            var spread = dir === 'u' ? 0.006 : 0.0075;
            var t0 = engine.ctx.currentTime + 0.005;
            var list = strings.map(function (x, j) {
                return { t: t0 + j * spread * (0.8 + Math.random() * 0.4), type: 'on', s: x[0], fret: x[1], vel: clamp(vel * (0.94 + Math.random() * 0.1) * (1 - j * 0.02), 0.2, 1), o: noteOpts(x[1], dir === 'u' ? { up: true } : null) };
            });
            engine.play(list);
            strings.forEach(function (x, j) { setTimeout(function () { neck.hit(x[0], x[1]); }, j * 8); });
            [].forEach.call($('eg-pads').children, function (p, k) { p.classList.toggle('cur', k === i); });
            lastChord = { strings: strings.map(function (x) { return x[0]; }), t: performance.now() };
            stats.strums++; bump(strumVia, st.lastInput || 'pad'); heard();
            // Shift or the palm-mute switch: a chug - it used to count only single notes
            if (st.pm || st.shift) stats.pm++;
        }
        function mutePad(i) {
            var c = pads[i];
            if (!c || !c.frets) return;
            var list = [];
            c.frets.forEach(function (f, s) { if (f >= 0) { list.push({ type: 'off', s: s, rel: 0.06 }); delete sounding[s]; } });
            engine.play(list);
        }

        // ─────────────────────────── neck gestures ────────────────────────
        var touches = {};          // pointer id -> {s, fret, bend, since}
        var vibTimers = {};
        /* A down waits for the engine (first touch, or a context the browser
           resumes asynchronously); a finger lifted before that used to find no
           record, and the string stayed "held" for good - vibrato on at 480 ms,
           later chords never damped it, the next touch read as a hammer-on from
           a ghost fret. The early lift is noted and applied after the note. */
        var pendingDown = {};
        neck.on(function (type, d) {
            if (type === 'down') {
                var pd = pendingDown[d.id] = { since: performance.now(), up: 0 };
                withAudio(function () {
                    if (pendingDown[d.id] === pd) delete pendingDown[d.id];
                    // a second finger on a string already held: hammer-on
                    var held = null;
                    for (var k in touches) if (touches[k] && touches[k].s === d.s && k !== String(d.id)) held = touches[k];
                    if (held && d.fret > held.fret) {
                        engine.play({ type: 'on', s: d.s, fret: d.fret, vel: 0.7, o: { legato: true } });
                        stats.hammers++; heard();
                        neck.hit(d.s, d.fret);
                        touches[d.id] = { s: d.s, fret: d.fret, hammerFrom: held.fret, bend: 0 };
                    } else {
                        var vel = d.pressure && d.pressure > 0 && d.pressure !== 0.5 ? 0.55 + d.pressure * 0.45 : 0.82;
                        pluck(d.s, d.fret, vel, null, d.pointerType === 'touch' ? 'touch' : (d.pointerType === 'keyboard' ? 'neck_kbd' : 'mouse'));
                        touches[d.id] = { s: d.s, fret: d.fret, bend: 0, since: pd.since };
                        armAutoVib(d.id, d.s);
                    }
                    neck.hold(d.id, d.s, d.fret);
                    if (pd.up) releaseTouch(d.id, pd.up - pd.since);
                });
            } else if (type === 'move') {
                var t = touches[d.id];
                if (!t) return;
                var semis = d.bendRows > 0.18 ? clamp((d.bendRows - 0.18) * 1.7, 0, 2) : 0;
                if (Math.abs(semis - t.bend) > 0.04) {
                    t.bend = semis;
                    engine.play({ type: 'bend', s: t.s, semis: semis, sec: 0.03 });
                    if (!t.bentOnce && semis > 0.3) { t.bentOnce = true; stats.bends++; }
                } else if (semis === 0 && d.fret !== t.fret && t.bend === 0) {
                    engine.play({ type: 'slide', s: t.s, fret: d.fret, sec: Math.min(0.25, 0.028 * Math.abs(d.fret - t.fret)) });
                    stats.slides++; heard();
                    t.fret = d.fret;
                    neck.hold(d.id, t.s, d.fret);
                }
            } else if (type === 'up') {
                var p0 = pendingDown[d.id];
                if (p0) { p0.up = performance.now(); neck.hold(d.id, null); return; }
                releaseTouch(d.id);
            }
        });
        function releaseTouch(id, heldMs) {
            var u = touches[id];
            delete touches[id];
            neck.hold(id, null);
            clearTimeout(vibTimers[id]);
            if (!u) return;
            if (u.bend > 0) engine.play({ type: 'bend', s: u.s, semis: 0, sec: 0.08 });
            if (u.vib) vib(u.s, false);
            if (u.hammerFrom !== undefined) {
                // lifting the hammering finger: pull-off back to the held fret
                engine.play({ type: 'on', s: u.s, fret: u.hammerFrom, vel: 0.62, o: { legato: true } });
                neck.hit(u.s, u.hammerFrom);
            } else {
                var other = false;
                for (var k2 in touches) if (touches[k2] && touches[k2].s === u.s) other = true;
                if (!other) lift(u.s, heldMs !== undefined ? heldMs : performance.now() - (u.since || 0));
            }
        }
        function armAutoVib(id, s) {
            clearTimeout(vibTimers[id]);
            if (!st.autoVib) return;
            vibTimers[id] = setTimeout(function () {
                var t = touches[id];
                if (t && t.bend === 0) { t.vib = true; vib(s, true); }
            }, 480);
        }

        // ─────────────────────────── computer keyboard ────────────────────
        var EASY_ROWS = [
            ['KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period', 'Slash'],
            ['KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote'],
            ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight']
        ];
        var TAB_ROWS = [
            ['Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0', 'Minus', 'Equal'],
            ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight'],
            ['KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote'],
            ['KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period', 'Slash']
        ];
        /* The scale laid out as positions a hand can reach, low to high: the
           easy scheme walks it key by key, so every key is a right note. */
        var scaleMap = [];
        function buildScaleMap() {
            var tun = tuningArr(), n = tun.length, capo = st.guitar.capo;
            var pcs = (P.SCALES[st.jam.scale] || P.SCALES.minpent).map(function (i) { return (P.NOTE[st.jam.key] + i) % 12; });
            var rootPc = P.NOTE[st.jam.key];
            // box: around the root on the low string
            var low = n - 1, base = ((rootPc - (tun[low] + capo)) % 12 + 12) % 12;
            if (base > 9) base -= 12;
            if (base < 0) base += 12;
            var out = [], seen = {};
            var lo = Math.max(0, base - 1), hi = base + 4;
            for (var pass = 0; pass < 3; pass++) {
                for (var s = n - 1; s >= 0; s--) {
                    for (var f = lo; f <= hi; f++) {
                        var m = tun[s] + capo + f;
                        if (pcs.indexOf(((m % 12) + 12) % 12) < 0 || seen[m]) continue;
                        seen[m] = 1;
                        out.push({ s: s, fret: f, midi: m });
                    }
                }
                lo = hi + 1; hi = lo + 4;
                if (hi > modelDef().frets) break;
            }
            out.sort(function (a, b) { return a.midi - b.midi; });
            scaleMap = out;
        }
        function easyNote(code) {
            var idx = -1, off = 0;
            for (var r = 0; r < EASY_ROWS.length; r++) {
                var i = EASY_ROWS[r].indexOf(code);
                if (i >= 0) { idx = off + i; break; }
                off += EASY_ROWS[r].length;
            }
            if (idx < 0 || idx >= scaleMap.length) return null;
            return scaleMap[idx];
        }
        function tabNote(code) {
            var n = tuningArr().length;
            var group = st.tabSet ? [0, 1, 2, 3] : [n - 4, n - 3, n - 2, n - 1];
            for (var r = 0; r < TAB_ROWS.length; r++) {
                var i = TAB_ROWS[r].indexOf(code);
                if (i >= 0) return { s: group[r], fret: st.tabPos + i };
            }
            return null;
        }
        var keyDown = {};
        // the tool is #eg-root - and the play-mode box, which lives outside it on <body>
        function inTool(el) {
            return !!el && !!el.closest && (!!el.closest('#eg-root') || (!!stageBox && stageBox.contains(el)));
        }
        /* The keyboard is an instrument here. Once it plays (has-kb) and while
           the focus is on the instrument, the page claims the keys
           (body[data-kbd-capture], the site's convention for keyboard-driven
           tools): the site-wide shortcut log counted every chug and every
           Escape - 37 437 "hotkey" events in October, a third of this tool's
           telemetry, for a keyboard eg_session already sums - and the site's
           Space/Escape shortcuts have nothing to do on the instrument. Focus in
           the site's chrome (search, a dialog, the comments) gives the keys
           back, so Escape still closes the site's own dialogs there. */
        function claimKeys() {
            var a = document.activeElement;
            var on = rootEl.classList.contains('has-kb') && (!a || a === document.body || inTool(a));
            if (on) document.body.setAttribute('data-kbd-capture', '1'); else document.body.removeAttribute('data-kbd-capture');
        }
        /* A list chosen with the mouse (scale, key, tuning...) keeps the focus,
           and a list takes the letter keys for itself (it jumps to an option
           by its first letter): a person who picked "Harmonic minor" and then
           played it from the keyboard heard nothing and moved the list. Picked
           with the mouse or a finger, the list gives the keys back; picked
           from the keyboard, it keeps them (arrow by arrow through options). */
        document.addEventListener('change', function (ev) {
            var t = ev.target, own = window.__keyOwnedByFocus;
            if (!t || t.tagName !== 'SELECT' || !inTool(t) || !own || !own.byKeyboard || own.byKeyboard(t)) return;
            try { t.blur(); } catch (x) {}
        }, true);
        document.addEventListener('focusin', claimKeys);
        document.addEventListener('focusout', function () { setTimeout(claimKeys, 0); });
        document.addEventListener('keydown', function (ev) {
            if (ev.ctrlKey || ev.metaKey || ev.altKey) return;
            /* Whose key is it is decided by what the focused element does with
               it (the site's primitive), not by its tag: a slider owns the
               arrows but not the letters - after "Position" or a knob the
               letter keys play again (a tag rule silenced them); a button or a
               checkbox keeps Space and Enter only when the keyboard brought the
               focus there - clicked with the mouse, Space bends instead of
               pressing it a second time. */
            if (window.__keyOwnedByFocus && window.__keyOwnedByFocus(ev)) return;
            var code = ev.code;
            // Escape closes play mode wherever the focus went
            if (code === 'Escape' && stageBox) { stopRiff(); engine.stopAll(); sounding = {}; exitPlay(); return; }
            if (!rootEl.classList.contains('has-kb') && code && !/^(Shift|Control|Alt|Meta|Tab|Escape)/.test(code)) { rootEl.classList.add('has-kb'); claimKeys(); }
            var ae0 = document.activeElement;
            // focus is in site chrome (menus, search): the page keys are not ours
            if (ae0 && ae0 !== document.body && !inTool(ae0)) return;
            if (code === 'ShiftLeft' || code === 'ShiftRight') { st.shift = true; $('eg-pm').setAttribute('aria-pressed', 'true'); return; }
            if (ev.repeat) { if (code === 'Space') ev.preventDefault(); return; }
            if (code === 'Escape') { stopRiff(); engine.stopAll(); sounding = {}; return; }
            if (code === 'Space') {
                ev.preventDefault();
                bendDown();
                keyDown[code] = true;
                return;
            }
            if (st.kb === 'easy' && /^Digit[1-8]$/.test(code)) {
                ev.preventDefault();
                var i = +code.slice(5) - 1;
                st.lastInput = 'keyboard';
                withAudio(function () { strumPad(i, null); });
                keyDown[code] = { pad: i, since: performance.now() };
                return;
            }
            if (code === 'ArrowDown' || code === 'ArrowUp') {
                if (document.activeElement === $('eg-neck')) return;
                ev.preventDefault();
                withAudio(function () { strumPad(lastPad, code === 'ArrowUp' ? 'u' : 'd'); });
                return;
            }
            if (st.kb === 'tab' && (code === 'ArrowLeft' || code === 'ArrowRight')) {
                if (document.activeElement === $('eg-neck')) return;
                ev.preventDefault();
                st.tabPos = clamp(st.tabPos + (code === 'ArrowRight' ? 1 : -1), 0, modelDef().frets - 11);
                neck.set({ pos: Math.max(0, st.tabPos - 1) }); $('eg-pos').value = neck.pos;
                return;
            }
            if (st.kb === 'tab' && (code === 'Backquote' || code === 'Backslash')) { st.tabSet = st.tabSet ? 0 : 1; return; }
            var nt = st.kb === 'easy' ? easyNote(code) : tabNote(code);
            if (!nt) return;
            ev.preventDefault();
            st.lastInput = 'keyboard';
            var kd = keyDown[code] = { s: nt.s, fret: nt.fret, since: performance.now() };
            withAudio(function () {
                pluck(nt.s, nt.fret, 0.82, null, 'keyboard');
                /* the key may be up already (a first press waits for the engine to
                   start): only the press that is still held gets the vibrato - this
                   used to throw on the released key's missing record */
                if (st.autoVib && keyDown[code] === kd) kd.vt = setTimeout(function () { if (keyDown[code] === kd) { kd.vib = true; vib(nt.s, true); } }, 480);
            });
        });
        function releaseKey(code) {
            var k = keyDown[code];
            if (!k) return;
            delete keyDown[code];
            if (code === 'Space') { bendUp(); return; }
            if (k.pad !== undefined) { if (!st.ring && performance.now() - k.since >= TAP_MS) mutePad(k.pad); return; }
            clearTimeout(k.vt);
            if (k.vib) vib(k.s, false);
            var still = false;
            for (var c in keyDown) if (keyDown[c] && keyDown[c].s === k.s) still = true;
            if (!still) lift(k.s, performance.now() - (k.since || 0));
        }
        document.addEventListener('keyup', function (e) {
            var code = e.code;
            if (code === 'ShiftLeft' || code === 'ShiftRight') { st.shift = false; $('eg-pm').setAttribute('aria-pressed', st.pm ? 'true' : 'false'); return; }
            releaseKey(code);
        });
        /* The window lost focus with keys down: no keyup will come. Each held key
           is let go as if released (a bend comes back, a vibrato stops, a held
           note is damped) and palm mute shows its real state again. */
        window.addEventListener('blur', function () {
            st.shift = false;
            $('eg-pm').setAttribute('aria-pressed', st.pm ? 'true' : 'false');
            Object.keys(keyDown).forEach(releaseKey);
            keyDown = {};
        });

        // ─────────────────────────── MIDI in ──────────────────────────────
        function midiNoteToPos(m) {
            var tun = tuningArr(), capo = st.guitar.capo, best = null;
            for (var s = tun.length - 1; s >= 0; s--) {
                var f = m - (tun[s] + capo);
                if (f < 0 || f > modelDef().frets) continue;
                var cost = Math.abs(f - (neck.pos + 2));
                if (!best || cost < best.cost) best = { s: s, fret: f, cost: cost };
            }
            return best;
        }
        var midiHeld = {}, midiSustained = {};
        function midiMsg(ev) {
            var d = ev.data, cmd = d[0] & 0xf0;
            if (cmd === 0x90 && d[2] > 0) {
                var pos = midiNoteToPos(d[1]);
                if (!pos) return;
                midiHeld[d[1]] = pos;
                st.lastInput = 'midi';
                withAudio(function () { pluck(pos.s, pos.fret, clamp(d[2] / 127, 0.2, 1), null, 'midi'); });
            } else if (cmd === 0x80 || (cmd === 0x90 && d[2] === 0)) {
                var p2 = midiHeld[d[1]]; delete midiHeld[d[1]];
                if (p2) { if (st.ring) midiSustained[p2.s] = 1; else release(p2.s); }
            } else if (cmd === 0xE0 && lastSingle) {
                var v = ((d[2] << 7) | d[1]) - 8192;
                engine.play({ type: 'bend', s: lastSingle.s, semis: clamp(v / 8192 * 2, 0, 2), sec: 0.01 });
            } else if (cmd === 0xB0 && d[1] === 64) {
                /* The sustain pedal is "let ring" for the engine too, and lifting it
                   lets go of the notes it was holding. It used to flip only the
                   button: the engine kept damping, and notes released under the
                   pedal rang until they died out. */
                var down = d[2] >= 64;
                if (down === st.ring) return;
                st.ring = down; $('eg-ring').setAttribute('aria-pressed', down ? 'true' : 'false');
                engine.play({ type: 'ring', on: down });
                if (!down) {
                    var heldS = {};
                    for (var mk in midiHeld) heldS[midiHeld[mk].s] = 1;
                    Object.keys(midiSustained).forEach(function (s) { if (!heldS[s]) release(+s); });
                    midiSustained = {};
                }
            } else if (cmd === 0xB0 && d[1] === 1 && lastSingle) {
                engine.play({ type: 'vib', s: lastSingle.s, depth: d[2] / 127 * 0.5, rate: 5.5 });
            }
        }
        /* The connection is the shared MidiInput (public/js/midi-input.js): every
           refusal named with its way out (a press used to answer a closed prompt, a
           blocked site and a busy port alike with «no MIDI device»), hot-plug, a port
           another program holds, a keyboard allowed before reconnecting on reload.
           midiMsg above keeps what a note does. A browser without Web MIDI at all
           (Safari, iPhone) still gets no line here: MIDI is a side door on this
           instrument, not the reason to come. */
        var MI = window.MidiInput;
        if (MI && (MI.support() === 'ok' || MI.support() === 'insecure')) {
            var midiSess = MI.session({
                slug: 'electric-guitar',
                onMessage: function (m, port, ev) { midiMsg(ev); },
                onState: function (s, change) {
                    $('eg-midi-state').textContent = s.status === 'on' ? tr('midi_on', { name: s.names })
                        : (s.status === 'none' ? T.midi_none : (MI.label(s) || T.midi_idle));
                    if (s.status === 'on') ae('eg_midi', { n: s.inputs.length });
                    MI.toastChange(change);
                }
            });
            $('eg-midi-state').addEventListener('click', function () { midiSess.connect().then(MI.toastOutcome); });
            midiSess.reconnect();
        } else $('eg-midi-state').parentNode.hidden = true;

        // ─────────────────────────── the band ─────────────────────────────
        var jamOn = false;
        function jamState() {
            var p = st.preset;
            return { groove: p.jam.groove, bpm: st.jam.bpm, key: st.jam.key, scale: st.jam.scale, prog: p.jam.prog };
        }
        function refreshScale(chordPcs) {
            var sc = (P.SCALES[st.jam.scale] || P.SCALES.minpent).map(function (i) { return (P.NOTE[st.jam.key] + i) % 12; });
            neck.setScale(jamOn || st.showScale ? { pcs: sc, root: P.NOTE[st.jam.key], names: P.scaleNames(st.jam.key, st.jam.scale) } : null, chordPcs);
        }
        engine.on('bar', function (x) {
            var bar = x.bar;
            $('eg-chordnow').textContent = bar.chord;
            $('eg-barinfo').textContent = tr('bar', { n: x.n + 1 });
            var c = P.parseChord(bar.sym);
            var iv = CHORD_IV[c.q] || (c.minor ? CHORD_IV.m : CHORD_IV['']);
            refreshScale(iv.map(function (i) { return (bar.rootPc + i) % 12; }));
        });
        engine.on('beat', function (x) {
            var dots = $('eg-beats').children;
            for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === x.beat);
        });
        function setJam(on) {
            jamOn = on;
            $('eg-jam-btn').setAttribute('aria-pressed', on ? 'true' : 'false');
            $('eg-jam-lbl').textContent = on ? T.jam_stop : T.jam_start;
            $('eg-jam-btn2').setAttribute('aria-pressed', on ? 'true' : 'false');
            $('eg-jam-lbl2').textContent = on ? T.jam_stop : T.jam_start;
            if (on && !jamSince) { jamSince = performance.now(); stage('jamming'); }
            if (!on && jamSince) { stats.jamS += (performance.now() - jamSince) / 1000; jamSince = 0; }
            statDirty = true;
            stageSync();
            if (on) {
                engine.jam.drumsOn = st.jam.drums; engine.jam.bassOn = st.jam.bass; engine.jam.metronome = st.jam.metro;
                engine.jam.start(jamState());
                ae('eg_jam', { preset: st.preset.id, bpm: st.jam.bpm, key: st.jam.key });
            } else {
                engine.jam.stop();
                engine._sendBass([{ type: 'muteAll' }]);
                $('eg-chordnow').innerHTML = '&nbsp;'; $('eg-barinfo').textContent = '';
                [].forEach.call($('eg-beats').children, function (d) { d.classList.remove('on'); });
            }
            refreshScale(null);
        }
        $('eg-jam-btn').addEventListener('click', function () { withAudio(function () { setJam(!jamOn); }); });
        $('eg-jam-btn2').addEventListener('click', function () { withAudio(function () { setJam(!jamOn); }); });
        function setBpm(v) {
            st.jam.bpm = clamp(Math.round(v), 40, 260);
            $('eg-bpm').textContent = st.jam.bpm;
            if (jamOn) engine.jam.update(jamState());
            applyDelaySync();
        }
        /* tap tempo: three taps set it, a pause of 2.5 s starts over */
        var taps = [];
        $('eg-tap').addEventListener('click', function () {
            var now = performance.now(), b = this;
            taps = taps.filter(function (t) { return now - t < 2500; });
            taps.push(now);
            b.classList.add('hit'); setTimeout(function () { b.classList.remove('hit'); }, 110);
            if (taps.length >= 3) setBpm(60000 * (taps.length - 1) / (taps[taps.length - 1] - taps[0]));
        });
        $('eg-bpm-dn').addEventListener('click', function () { setBpm(st.jam.bpm - 4); });
        $('eg-bpm-up').addEventListener('click', function () { setBpm(st.jam.bpm + 4); });
        /* A key or a scale picked by hand is shown on the neck at once, band or
           no band: it used to appear only while the band played (`showScale`
           was read and never set), so a person who chose a scale to practise
           saw nothing change. */
        $('eg-key').addEventListener('change', function () { st.jam.key = this.value; st.showScale = true; if (jamOn) engine.jam.update(jamState()); renderPads(); buildScaleMap(); refreshScale(null); });
        $('eg-scale').addEventListener('change', function () {
            st.jam.scale = this.value; st.showScale = true;
            // the band's chord names are spelled in the scale too (Bb minor, not A# minor)
            if (jamOn) engine.jam.update(jamState());
            buildScaleMap(); refreshScale(null); renderPads();
            ae('eg_scale', { id: st.jam.scale, preset: st.preset && st.preset.id });
        });
        function toggleBtn(id, key, fn) {
            $(id).addEventListener('click', function () {
                var on = this.getAttribute('aria-pressed') !== 'true';
                this.setAttribute('aria-pressed', on ? 'true' : 'false');
                fn(on);
            });
        }
        toggleBtn('eg-drums', 'drums', function (on) { st.jam.drums = on; if (engine.jam) engine.jam.drumsOn = on; });
        toggleBtn('eg-bass', 'bass', function (on) { st.jam.bass = on; if (engine.jam) engine.jam.bassOn = on; });
        toggleBtn('eg-metro', 'metro', function (on) { st.jam.metro = on; if (engine.jam) engine.jam.metronome = on; });
        $('eg-bandvol').addEventListener('input', function () { st.jam.vol = this.value / 100; if (engine.jamBus) engine.jamBus.gain.value = st.jam.vol; });

        // ─────────────────────────── the riff ─────────────────────────────
        var tab = new UI.Tab($('eg-tab'));
        var riffRun = null, riffSpeed = 1, riffLoop = false;
        function stopRiff() {
            if (!riffRun) return;
            riffRun.stop = true;
            cancelAnimationFrame(riffRun.raf);
            clearTimeout(riffRun.loopT);
            riffRun = null;
            engine.stopRiff();
            neck.setTargets([]);
            $('eg-riff-lbl').textContent = T.riff_listen;
        }
        function playRiff() {
            var p = st.preset;
            var bpm = st.jam.bpm * riffSpeed;
            var when = null;
            if (jamOn && engine.jam.playing) {
                // start on the next bar line so the riff sits in the groove
                var pos = engine.jam.position();
                var spb = 60 / st.jam.bpm;
                when = engine.jam.startTime + (Math.floor(Math.max(0, pos.bar) + 1) * 4) * spb;
                bpm = st.jam.bpm;
            }
            var r = engine.playRiff(p.riff, { bpm: bpm, when: when });
            var names = tuningArr().map(function (m) { return UI.noteName(m + st.guitar.capo, st.names); });
            tab.render(r.cells, p.riff.beats, tuningArr().length, names);
            $('eg-tab').hidden = false; $('eg-riffctl').hidden = false;
            $('eg-riff-lbl').textContent = T.riff_stop;
            var run = { t0: r.t0, spb: 60 / bpm, beats: p.riff.beats, cells: r.cells };
            riffRun = run;
            (function frame() {
                if (run.stop) return;
                var beat = (engine.ctx.currentTime - run.t0) / run.spb;
                tab.at(clamp(beat, 0, run.beats));
                var next = run.cells.filter(function (c) { return c.beat >= beat - 0.05; }).slice(0, 3);
                var tg = []; var seenB = null;
                next.forEach(function (c) { if (seenB === null) seenB = c.beat; if (c.beat === seenB || tg.length < 1) tg.push({ s: c.s, fret: c.fret }); });
                neck.setTargets(tg);
                if (beat >= run.beats) {
                    neck.setTargets([]);
                    if (riffLoop && !run.stop) { riffRun = null; playRiff(); return; }
                    riffRun = null;
                    $('eg-riff-lbl').textContent = T.riff_listen;
                    return;
                }
                // a hidden tab gets no animation frames: keep the loop going on a timer
                if (document.hidden) run.loopT = setTimeout(frame, 200);
                else run.raf = requestAnimationFrame(frame);
            }());
            ae('eg_riff', { preset: p.id, speed: riffSpeed, jam: jamOn ? 1 : 0 });
            stats.riffs++; statDirty = true;
        }
        $('eg-riff-btn').addEventListener('click', function () {
            withAudio(function () { if (riffRun) stopRiff(); else playRiff(); });
        });
        [].forEach.call(document.querySelectorAll('[data-speed]'), function (b) {
            b.addEventListener('click', function () {
                riffSpeed = +b.dataset.speed;
                [].forEach.call(document.querySelectorAll('[data-speed]'), function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            });
        });
        toggleBtn('eg-loop', 'loop', function (on) { riffLoop = on; });

        // ─────────────────────────── hands toggles ────────────────────────
        toggleBtn('eg-pm', 'pm', function (on) { st.pm = on; });
        toggleBtn('eg-ring', 'ring', function (on) { st.ring = on; engine.play({ type: 'ring', on: on }); });
        toggleBtn('eg-harm', 'harm', function (on) { st.harm = on; });
        /*
         * Bend (the button or Space, held): what is ringing is pulled up - the
         * last single note a whole tone, the last chord a semitone (a chord
         * bend). The button used to bend only the last SINGLE note, even one
         * long stopped: after chords, or before the first note, a press did
         * nothing and showed nothing - 242 "dead" presses in 121 sessions in
         * October, the tool's most pressed silent control, pressed again and
         * again like the switches beside it. Now it lights while held, and with
         * nothing ringing it says what to do.
         */
        var bendBtn = $('eg-bendbtn');
        var bentNow = null, hintT = 0;
        /* next to the hand buttons (they move into play mode with it): the take
           panel's status line is two panels below, and in play mode not drawn */
        function handsHint(text) {
            var h = $('eg-hint');
            clearTimeout(hintT);
            h.textContent = text; h.hidden = false;
            hintT = setTimeout(function () { h.hidden = true; }, 4000);
        }
        function bendTargets() {
            var out = [], single = lastSingle ? lastSingle.t : -1, chord = lastChord ? lastChord.t : -1;
            if (chord > single) lastChord.strings.forEach(function (s) { if (sounding[s]) out.push({ s: s, semis: 1 }); });
            else if (lastSingle && sounding[lastSingle.s]) out.push({ s: lastSingle.s, semis: 2 });
            return out;
        }
        function bendDown() {
            if (bentNow) return;
            bendBtn.classList.add('held');
            bentNow = bendTargets();
            if (!bentNow.length) {
                handsHint(T.bend_hint);
                return;
            }
            engine.play(bentNow.map(function (x) { return { type: 'bend', s: x.s, semis: x.semis, sec: 0.13 }; }));
            stats.bends++; statDirty = true;
        }
        function bendUp() {
            bendBtn.classList.remove('held');
            if (bentNow && bentNow.length) engine.play(bentNow.map(function (x) { return { type: 'bend', s: x.s, semis: 0, sec: 0.1 }; }));
            bentNow = null;
        }
        /* the button keeps the pointer: released outside it, the bend still comes
           back (it used to stay bent until the next note) */
        bendBtn.addEventListener('pointerdown', function (e) {
            e.preventDefault();
            try { bendBtn.setPointerCapture(e.pointerId); } catch (x) {}
            bendDown();
        });
        bendBtn.addEventListener('pointerup', bendUp);
        bendBtn.addEventListener('pointercancel', bendUp);
        bendBtn.addEventListener('lostpointercapture', bendUp);
        $('eg-kbbtn').addEventListener('click', function () {
            var open = $('eg-kb').hidden;
            $('eg-kb').hidden = !open;
            this.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        [].forEach.call(document.querySelectorAll('[data-kb]'), function (b) {
            b.addEventListener('click', function () {
                st.kb = b.dataset.kb;
                [].forEach.call(document.querySelectorAll('[data-kb]'), function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
                $('eg-kb-easy').hidden = st.kb !== 'easy'; $('eg-kb-tab').hidden = st.kb !== 'tab';
                savePrefs();
                ae('eg_kb', { scheme: st.kb });
            });
        });
        [].forEach.call(document.querySelectorAll('[data-ptype]'), function (b) {
            b.addEventListener('click', function () {
                st.padType = b.dataset.ptype;
                [].forEach.call(document.querySelectorAll('[data-ptype]'), function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
                renderPads(); savePrefs();
            });
        });
        $('eg-pos').addEventListener('input', function () { neck.set({ pos: +this.value }); });
        // `change` ends a person's gesture (a drag, a tap, a key); a value the page writes fires none
        $('eg-pos').addEventListener('change', function () { stats.posN++; statDirty = true; });
        $('eg-labels').addEventListener('click', function () {
            st.labels = !st.labels; this.setAttribute('aria-pressed', st.labels ? 'true' : 'false');
            neck.set({ labels: st.labels }); savePrefs();
        });
        $('eg-lefty').addEventListener('click', function () {
            st.lefty = !st.lefty; this.setAttribute('aria-pressed', st.lefty ? 'true' : 'false');
            neck.set({ lefty: st.lefty }); savePrefs();
            ae('eg_lefty', { on: st.lefty ? 1 : 0 });
        });

        // rig tabs: one layer of the chain at a time
        var rigTabs = document.querySelectorAll('.eg-rigtabs [role=tab]');
        [].forEach.call(rigTabs, function (tb) {
            tb.addEventListener('click', function () {
                [].forEach.call(rigTabs, function (x) {
                    var on = x === tb;
                    x.classList.toggle('on', on); x.setAttribute('aria-selected', on ? 'true' : 'false');
                    $('eg-pane-' + x.dataset.pane).hidden = !on;
                });
                stats.tabs++; statDirty = true;
            });
            tb.addEventListener('keydown', function (e) {
                if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
                e.preventDefault(); e.stopPropagation();
                var list = [].slice.call(rigTabs), i = list.indexOf(tb);
                var n = list[(i + (e.key === 'ArrowRight' ? 1 : -1) + list.length) % list.length];
                n.focus(); n.click();
            });
        });

        // ───────────────────────────── the rig UI ─────────────────────────
        var knobs = {};
        function pct(v) { return Math.round(v * 100) + ''; }
        /* one decimal in the page's own number format (3,2 in ru/de/fr...; the dot was
           hard-coded), and no space before a Korean/Japanese/Chinese unit */
        var fmt1 = (function () {
            try { var nf = new Intl.NumberFormat(window.__intlLocale && window.__intlLocale(), { minimumFractionDigits: 1, maximumFractionDigits: 1 }); return function (v) { return nf.format(v); }; }
            catch (e) { return function (v) { return (Math.round(v * 10) / 10).toFixed(1); }; }
        }());
        var unitSep = /^(ko|ja|zh)/.test(window.__LOCALE || document.documentElement.lang || '') ? '' : ' ';
        function num(v) { return fmt1(Math.round(v * 10) / 10); }
        function rigSet(path, v) {
            // path "amp.gain" / "pedals.drive.drive"
            var parts = path.split('.'), o = {}, cur = o;
            for (var i = 0; i < parts.length - 1; i++) { cur[parts[i]] = {}; cur = cur[parts[i]]; }
            cur[parts[parts.length - 1]] = v;
            st.rig = deepMerge(st.rig, o);
            engine.applyRig(o);
            st.dirty = true;
        }
        function deepMerge(a, b) {
            var out = Object.assign({}, a || {});
            for (var k in b) {
                var v = b[k];
                out[k] = (v && typeof v === 'object' && !Array.isArray(v)) ? deepMerge(out[k], v) : v;
            }
            return out;
        }
        var knobDone = debounce(function () { saveTone(); stats.tweaks++; statDirty = true; }, 1200);
        function knob(host, key, label, path, value, def, fmt, min, max, step) {
            knobs[key] = new UI.Knob(host, {
                label: label, value: value, def: def, fmt: fmt || pct, min: min, max: max, step: step,
                onInput: function (v) { rigSet(path, v); },
                onChange: function () { knobDone(); }
            });
            return knobs[key];
        }
        function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

        // guitar knobs
        var gk = $('eg-gknobs');
        function guitarKnob(key, label, get, set, fmt) {
            knobs[key] = new UI.Knob(gk, { label: label, value: get(), def: get(), fmt: fmt || pct, onInput: function (v) { set(v); }, onChange: function () { knobDone(); } });
        }
        guitarKnob('g_vol', T.k_volume, function () { return st.guitar.vol; }, function (v) { st.guitar.vol = v; engine.setGuitar({ vol: v }); });
        guitarKnob('g_tone', T.k_gtone, function () { return st.guitar.tone; }, function (v) { st.guitar.tone = v; engine.setGuitar({ tone: v }); });
        knobs.g_pick = new UI.Knob(gk, { label: T.k_pick, value: 85, def: 85, min: 30, max: 180, step: 1, fmt: function (v) { return Math.round(v) + ' ' + (T.u_mm || 'mm'); },
            onInput: function (v) { st.guitar.pickMm = v; engine.setGuitar({ pickMm: v }); }, onChange: function () { knobDone(); } });

        // pedals
        var pedalsHost = $('eg-pedals'), pedalUI = {};
        /* Every genre has the same pedals, amp knobs and effects - only their
           settings differ - so they are built once and a switch updates them
           in place (rebuilding the DOM was a third of a genre switch). */
        function buildPedals() {
            var pd = st.rig.pedals;
            if (pedalUI.comp) {
                pedalUI.comp.update(pd.comp.on, null, pd.comp);
                pedalUI.wah.update(pd.wah.on, pd.wah.mode || 'auto', pd.wah);
                pedalUI.boost.update(pd.boost.on, null, pd.boost);
                pedalUI.drive.update(pd.drive.on, pd.drive.type || 'od', pd.drive);
                return;
            }
            pedalsHost.innerHTML = '';
            pedalUI.comp = UI.Pedal(pedalsHost, {
                name: T.p_comp, hue: 200, on: pd.comp.on,
                knobs: [{ k: 'sustain', label: T.k_sustain, value: pd.comp.sustain !== undefined ? pd.comp.sustain : 0.5, def: 0.5 }, { k: 'level', label: T.k_level, value: pd.comp.level !== undefined ? pd.comp.level : 0.5, def: 0.5 }],
                onToggle: function (on) { rigSet('pedals.comp.on', on); knobDone(); },
                onKnob: function (k, v) { rigSet('pedals.comp.' + k, v); }, onKnobDone: knobDone
            }, T);
            pedalUI.wah = UI.Pedal(pedalsHost, {
                name: T.p_wah, hue: 280, on: pd.wah.on,
                select: { options: [['auto', T.wah_auto], ['manual', T.wah_manual]], value: pd.wah.mode || 'auto', onChange: function (v) { rigSet('pedals.wah.mode', v); } },
                knobs: [{ k: 'sens', label: T.k_sens, value: pd.wah.sens !== undefined ? pd.wah.sens : 0.5, def: 0.5 }, { k: 'pos', label: T.k_pos, value: pd.wah.pos !== undefined ? pd.wah.pos : 0.5, def: 0.5 }],
                onToggle: function (on) { rigSet('pedals.wah.on', on); knobDone(); },
                onKnob: function (k, v) { rigSet('pedals.wah.' + k, v); }, onKnobDone: knobDone
            }, T);
            pedalUI.boost = UI.Pedal(pedalsHost, {
                name: T.p_boost, hue: 130, on: pd.boost.on,
                knobs: [{ k: 'drive', label: T.k_drive, value: pd.boost.drive !== undefined ? pd.boost.drive : 0.15, def: 0.15 }, { k: 'level', label: T.k_level, value: pd.boost.level !== undefined ? pd.boost.level : 0.7, def: 0.7 }],
                onToggle: function (on) { rigSet('pedals.boost.on', on); knobDone(); },
                onKnob: function (k, v) { rigSet('pedals.boost.' + k, v); }, onKnobDone: knobDone
            }, T);
            var dv = pd.drive;
            pedalUI.drive = UI.Pedal(pedalsHost, {
                name: T.p_drive, hue: 18, on: dv.on,
                select: { options: [['od', T.drive_od], ['ds', T.drive_ds], ['fz', T.drive_fz], ['ge', T.drive_ge]], value: dv.type || 'od', onChange: function (v) { rigSet('pedals.drive.type', v); knobDone(); } },
                knobs: [{ k: 'drive', label: T.k_drive, value: dv.drive !== undefined ? dv.drive : 0.5, def: 0.5 }, { k: 'tone', label: T.k_tone, value: dv.tone !== undefined ? dv.tone : 0.5, def: 0.5 }, { k: 'level', label: T.k_level, value: dv.level !== undefined ? dv.level : 0.5, def: 0.5 }],
                onToggle: function (on) { rigSet('pedals.drive.on', on); knobDone(); },
                onKnob: function (k, v) { rigSet('pedals.drive.' + k, v); }, onKnobDone: knobDone
            }, T);
        }
        // amp
        var ak = $('eg-aknobs');
        function buildAmp() {
            var a = st.rig.amp;
            if (knobs.a_gain) {
                ['gain', 'bass', 'mid', 'treble', 'presence', 'res', 'master'].forEach(function (k) {
                    var v = a[k] !== undefined ? a[k] : 0.5;
                    knobs['a_' + k].o.def = v;           // a double-click returns to the preset
                    knobs['a_' + k].set(v);
                });
                $('eg-ampmodel').value = a.model;
                knobs.c_mic.set(st.rig.cab.mic !== undefined ? st.rig.cab.mic : 0.5);
                $('eg-cab').value = st.rig.cab.type;
                return;
            }
            ak.innerHTML = '';
            [['gain', T.k_gain], ['bass', T.k_bass], ['mid', T.k_mid], ['treble', T.k_treble], ['presence', T.k_presence], ['res', T.k_res], ['master', T.k_master]].forEach(function (x) {
                knob(ak, 'a_' + x[0], x[1], 'amp.' + x[0], a[x[0]] !== undefined ? a[x[0]] : 0.5, a[x[0]] !== undefined ? a[x[0]] : 0.5, function (v) { return num(v * 10); });
            });
            $('eg-ampmodel').value = a.model;
            var ck = $('eg-cknobs'); ck.innerHTML = '';
            knob(ck, 'c_mic', T.k_mic, 'cab.mic', st.rig.cab.mic !== undefined ? st.rig.cab.mic : 0.5, 0.5);
            $('eg-cab').value = st.rig.cab.type;
        }
        $('eg-ampmodel').addEventListener('change', function () { rigSet('amp.model', this.value); knobDone(); });
        $('eg-cab').addEventListener('change', function () { rigSet('cab.type', this.value); knobDone(); });
        // effects
        var fxHost = $('eg-fx'), fxUI = {};
        function buildFx() {
            var r = st.rig;
            if (fxUI.mod) {
                fxUI.mod.update(r.mod.on, r.mod.type || 'chorus', r.mod);
                fxUI.delay.update(r.delay.on, r.delay.type || 'analog', { time: r.delay.time || null, fb: r.delay.fb, mix: r.delay.mix });
                fxUI.reverb.update(r.reverb.on, r.reverb.type || 'plate', r.reverb);
                return;
            }
            fxHost.innerHTML = '';
            fxUI.mod = UI.Pedal(fxHost, {
                name: T.p_mod, hue: 190, on: !!r.mod.on,
                select: { options: [['chorus', T.mod_chorus], ['flanger', T.mod_flanger], ['phaser', T.mod_phaser], ['tremolo', T.mod_tremolo], ['vibe', T.mod_vibe]], value: r.mod.type || 'chorus', onChange: function (v) { rigSet('mod.type', v); knobDone(); } },
                knobs: [{ k: 'rate', label: T.k_rate, value: r.mod.rate !== undefined ? r.mod.rate : 0.4, def: 0.4 }, { k: 'depth', label: T.k_depth, value: r.mod.depth !== undefined ? r.mod.depth : 0.5, def: 0.5 }, { k: 'mix', label: T.k_mix, value: r.mod.mix !== undefined ? r.mod.mix : 0.5, def: 0.5 }],
                onToggle: function (on) { rigSet('mod.on', on); if (on && !st.rig.mod.type) rigSet('mod.type', 'chorus'); knobDone(); },
                onKnob: function (k, v) { rigSet('mod.' + k, v); }, onKnobDone: knobDone
            }, T);
            fxUI.delay = UI.Pedal(fxHost, {
                name: T.p_delay, hue: 50, on: !!r.delay.on,
                select: { options: [['analog', T.delay_analog], ['tape', T.delay_tape], ['digital', T.delay_digital]], value: r.delay.type || 'analog', onChange: function (v) { rigSet('delay.type', v); knobDone(); } },
                knobs: [{ k: 'time', label: T.k_time, value: r.delay.time || 0.38, def: 0.38, min: 0.05, max: 1.2, step: 0.005, fmt: function (v) { return Math.round(v * 1000) + ' ' + (T.u_ms || 'ms'); } },
                    { k: 'fb', label: T.k_fb, value: r.delay.fb !== undefined ? r.delay.fb : 0.3, def: 0.3, max: 0.85 }, { k: 'mix', label: T.k_mix, value: r.delay.mix !== undefined ? r.delay.mix : 0.25, def: 0.25 }],
                onToggle: function (on) { rigSet('delay.on', on); knobDone(); },
                onKnob: function (k, v) { if (k === 'time') { st.delaySynced = false; } rigSet('delay.' + k, v); }, onKnobDone: knobDone
            }, T);
            fxUI.reverb = UI.Pedal(fxHost, {
                name: T.p_reverb, hue: 230, on: !!r.reverb.on,
                select: { options: [['room', T.rev_room], ['plate', T.rev_plate], ['hall', T.rev_hall], ['spring', T.rev_spring], ['huge', T.rev_huge], ['reverse', T.rev_reverse]], value: r.reverb.type || 'plate', onChange: function (v) { rigSet('reverb.type', v); knobDone(); } },
                knobs: [{ k: 'decay', label: T.k_decay, value: r.reverb.decay !== undefined ? r.reverb.decay : 0.5, def: 0.5 }, { k: 'mix', label: T.k_mix, value: r.reverb.mix !== undefined ? r.reverb.mix : 0.2, def: 0.2 }],
                onToggle: function (on) { rigSet('reverb.on', on); knobDone(); },
                onKnob: function (k, v) { rigSet('reverb.' + k, v); }, onKnobDone: knobDone
            }, T);
        }
        /* A synced delay follows the band's tempo; a hand-set time stays put. */
        function applyDelaySync() {
            var p = st.preset;
            if (!p || !p.delay || !p.delay.sync || st.delaySynced === false) return;
            var time = (60 / st.jam.bpm) * (P.SYNC[p.delay.sync] || 1);
            rigSet('delay.time', time);
            if (fxUI.delay && fxUI.delay.knobs.time) fxUI.delay.knobs.time.set(time);
        }
        // settings knobs
        var sk = $('eg-sknobs');
        knobs.s_noise = new UI.Knob(sk, { label: T.k_noise, value: st.guitar.noise, def: 0.6, max: 1.5, onInput: function (v) { st.guitar.noise = v; engine.setNoise(v, st.hum); }, onChange: function () { savePrefs(); } });
        knobs.s_symp = new UI.Knob(sk, { label: T.k_sympathy, value: st.guitar.sympathy, def: 0.35, onInput: function (v) { st.guitar.sympathy = v; engine.setGuitar({ sympathy: v }); }, onChange: function () { knobDone(); } });
        $('eg-hum').value = String(st.hum);
        $('eg-hum').addEventListener('change', function () { st.hum = +this.value; engine.setNoise(st.guitar.noise, st.hum); savePrefs(); });
        $('eg-names').value = st.names;
        $('eg-names').addEventListener('change', function () { st.names = this.value; neck.set({ nameStyle: st.names }); savePrefs(); });
        $('eg-autovib').checked = st.autoVib;
        $('eg-autovib').addEventListener('change', function () { st.autoVib = this.checked; savePrefs(); });
        $('eg-master').value = Math.round(st.master * 100);
        $('eg-master').addEventListener('input', function () { st.master = this.value / 100; if (engine.master) engine.master.gain.value = st.master; });
        $('eg-master').addEventListener('change', savePrefs);

        // guitar model / pickup / tuning / capo
        var modelBtns = document.querySelectorAll('[data-model]');
        function renderModels() {
            [].forEach.call(modelBtns, function (b) { var on = b.dataset.model === st.guitar.model; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
            var m = modelDef(), host = $('eg-pickups');
            /* the same guitar: the buttons stay, only their state changes - rebuilding
               them on every pickup click threw the keyboard focus back to <body> */
            var same = host.children.length === m.order.length && m.order.every(function (sel, i) { return host.children[i].dataset.sel === sel; });
            if (same) {
                [].forEach.call(host.children, function (b) { var on = b.dataset.sel === st.guitar.sel; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
                return;
            }
            var hadFocus = host.contains(document.activeElement);
            host.innerHTML = '';
            m.order.forEach(function (sel) {
                var b = document.createElement('button');
                b.type = 'button'; b.className = 'tc-seg-b' + (sel === st.guitar.sel ? ' on' : '');
                b.dataset.sel = sel;
                b.setAttribute('aria-pressed', sel === st.guitar.sel ? 'true' : 'false');
                b.textContent = T['pickup_' + sel] || sel;
                b.addEventListener('click', function () { st.guitar.sel = sel; engine.setGuitar({ sel: sel }); renderModels(); knobDone(); });
                host.appendChild(b);
            });
            if (hadFocus) { var onB = host.querySelector('.on'); if (onB) onB.focus({ preventScroll: true }); }
        }
        [].forEach.call(modelBtns, function (b) {
            b.addEventListener('click', function () {
                var m = b.dataset.model;
                st.guitar.model = m;
                st.guitar.sel = Core.MODELS[m].def;
                var seven = Core.MODELS[m].strings === 7, isSeven = /7/.test(st.guitar.tuning);
                if (seven !== isSeven) { st.guitar.tuning = seven ? 'b7' : 'std'; $('eg-tuning').value = st.guitar.tuning; }
                engine.setGuitar({ model: m, sel: st.guitar.sel, tuning: st.guitar.tuning });
                renderModels(); syncNeck(); renderPads(); buildScaleMap(); refreshScale(null);
                knobDone();
            });
        });
        $('eg-tuning').addEventListener('change', function () {
            var tn = this.value;
            var seven = /7/.test(tn);
            if (seven && Core.MODELS[st.guitar.model].strings !== 7) { st.guitar.model = 's7'; st.guitar.sel = 'b'; }
            if (!seven && Core.MODELS[st.guitar.model].strings === 7) { st.guitar.model = 'ss'; st.guitar.sel = 'b'; }
            st.guitar.tuning = tn;
            engine.setGuitar({ tuning: tn, model: st.guitar.model, sel: st.guitar.sel });
            renderModels(); syncNeck(); renderPads(); buildScaleMap(); refreshScale(null);
            ae('eg_tuning', { t: tn });
        });
        $('eg-capo').addEventListener('change', function () {
            st.guitar.capo = +this.value;
            engine.setGuitar({ capo: st.guitar.capo });
            syncNeck(); renderPads(); buildScaleMap();
        });

        // ───────────────────────────── presets ────────────────────────────
        var genreBtns = document.querySelectorAll('[data-genre]');
        function applyPreset(id, opts) {
            opts = opts || {};
            var p = P.byId(id) || P.PRESETS[0];
            stopRiff();
            st.preset = p;
            st.dirty = false;
            st.delaySynced = true;
            st.guitar = Object.assign({}, st.guitar, {
                model: p.guitar.model, sel: p.guitar.sel, tuning: p.guitar.tuning, capo: 0, tone: p.guitar.tone, vol: p.guitar.vol,
                pickMm: p.guitar.pickMm, sympathy: p.guitar.sympathy
            });
            st.jam.bpm = p.jam.bpm; st.jam.key = p.jam.key; st.jam.scale = p.jam.scale;
            st.rig = P.rigFor(p, st.jam.bpm, Core.MODELS);
            if (opts.overrides) st.rig = deepMerge(st.rig, opts.overrides);
            /* a saved or shared tone brings its capo back (the select shows it below);
               noise is the person's own setting (prefs), not part of a tone - an old saved
               tone used to overwrite it, and the knob showed one value while the engine had another */
            if (opts.guitar) { var og = Object.assign({}, opts.guitar); delete og.noise; Object.assign(st.guitar, og); }
            // UI
            [].forEach.call(genreBtns, function (b) { var on = b.dataset.genre === p.id; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
            var gk2 = p.id.replace(/-/g, '_');
            $('eg-now-name').textContent = T['genre_' + gk2] || p.id;
            $('eg-now-desc').textContent = T['genre_' + gk2 + '_desc'] || '';
            var tags = $('eg-now-tags'); tags.innerHTML = '';
            [T['model_' + p.guitar.model], T['amp_' + p.amp.model], T['tuning_' + p.guitar.tuning], tr('tag_bpm', { n: p.jam.bpm })].forEach(function (x) {
                if (!x) return; var s = document.createElement('span'); s.className = 'eg-tag'; s.textContent = x; tags.appendChild(s);
            });
            $('eg-tuning').value = st.guitar.tuning; $('eg-capo').value = String(st.guitar.capo || 0);
            $('eg-bpm').textContent = st.jam.bpm; $('eg-key').value = st.jam.key; $('eg-scale').value = st.jam.scale;
            knobs.g_vol.set(st.guitar.vol); knobs.g_tone.set(st.guitar.tone); knobs.g_pick.set(st.guitar.pickMm); knobs.s_symp.set(st.guitar.sympathy);
            renderModels(); syncNeck(); buildPedals(); buildAmp(); buildFx(); renderPads(); buildScaleMap(); refreshScale(null);
            // sound - also before the first touch: a graph prepared in idle
            // time is built with this preset instead of rebuilt on the touch
            engine.setGuitar(st.guitar);
            engine.applyRig(st.rig);
            if (st.started && jamOn) engine.jam.update(jamState());
            save('preset', p.id);
            if (!opts.silent) { ae('eg_preset', { id: p.id }); stats.gsw++; }
            stats.genres[p.id] = 1;
            if (stageSel) stageSel.value = p.id;
        }
        [].forEach.call(genreBtns, function (b) {
            b.addEventListener('click', function () {
                applyPreset(b.dataset.genre);
                withAudio(function () {});
            });
        });
        function saveTone() { var g = Object.assign({}, st.guitar); delete g.noise; save('tone', { id: st.preset.id, rig: st.rig, guitar: g }); }
        $('eg-now-desc').addEventListener('click', function () { this.classList.toggle('open'); });

        // share: the whole tone in the URL, compact
        function encodeTone() {
            var o = { p: st.preset.id, r: st.rig, g: { model: st.guitar.model, sel: st.guitar.sel, tuning: st.guitar.tuning, tone: st.guitar.tone, vol: st.guitar.vol, pickMm: st.guitar.pickMm } };
            var s = JSON.stringify(o);
            return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        }
        function decodeTone(s) {
            try { return JSON.parse(decodeURIComponent(escape(atob(s.replace(/-/g, '+').replace(/_/g, '/'))))); } catch (e) { return null; }
        }
        $('eg-share').addEventListener('click', function () {
            var url = location.origin + location.pathname + '?tone=' + encodeTone();
            var done = function () { toast(T.share_copied, 'success'); };
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { prompt(T.share_failed || '', url); });
            else prompt(T.share_failed || '', url);
            ae('eg_share', { preset: st.preset.id });
        });
        $('eg-reset').addEventListener('click', function () { applyPreset(st.preset.id); save('tone', null); });

        // ───────────────────────────── takes ──────────────────────────────
        var recTimer = null;
        $('eg-rec').addEventListener('click', function () {
            var btn = this;
            withAudio(function () {
                if (engine.take) {
                    clearInterval(recTimer);
                    btn.setAttribute('aria-pressed', 'false');
                    $('eg-rec-lbl').textContent = T.rec_start;
                    stageSync();
                    stopTake();
                    engine.stopTake().then(function (tk) {
                        /* an empty take clears the previous one: its panel used to stay, and
                           WAV/MP3 quietly exported the older take under "empty" */
                        if (!tk) { engine.lastTake = null; rendered = null; $('eg-take').hidden = true; $('eg-reamp').hidden = true; $('eg-rec-time').textContent = T.take_empty; return; }
                        $('eg-take').hidden = false; $('eg-reamp').hidden = false;
                        // a take of the real guitar alone has no notes: no empty MIDI file
                        $('eg-dl-midi').hidden = !tk.events.some(function (e) { return e.type === 'on'; });
                        $('eg-rec-time').textContent = tr('take_len', { s: fmt1(tk.seconds) });
                        ae('eg_take', { sec: Math.round(tk.seconds), n: tk.events.length, di: tk.di ? 1 : 0, jam: (tk.drums && tk.drums.length) || (tk.bass && tk.bass.length) ? 1 : 0 });
                        stats.takes++; statDirty = true;
                        stage('recorded', { sec: Math.round(tk.seconds) });
                    });
                } else {
                    engine.startTake();
                    btn.setAttribute('aria-pressed', 'true');
                    $('eg-rec-lbl').textContent = T.rec_stop;
                    stageSync();
                    var t0 = performance.now();
                    recTimer = setInterval(function () { $('eg-rec-time').textContent = fmt1((performance.now() - t0) / 1000) + unitSep + (T.u_s || 's'); }, 200);
                }
            });
        });
        var rendering = false, rendered = null;
        /* One render feeds Listen, WAV and MP3; while it (or the MP3 encoder)
           runs, all three say so and wait. A press during the render used to be
           dropped without a sign ("busy") - 80 silent presses of Listen and 30
           of MP3 in October, the same people pressing again and again. */
        var takeBtns = ['eg-take-play', 'eg-dl-wav', 'eg-dl-mp3'];
        function takeBusy(on) {
            takeBtns.forEach(function (id) { var b = $(id); b.disabled = !!on; if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
        }
        var pct = (function () {
            try { var nf = new Intl.NumberFormat(window.__intlLocale && window.__intlLocale(), { style: 'percent' }); return function (f) { return nf.format(f); }; }
            catch (e) { return function (f) { return Math.round(f * 100) + '%'; }; }
        }());
        function renderTake() {
            var tk = engine.lastTake;
            if (!tk || rendering) return Promise.reject(new Error('busy'));
            var withBand = $('eg-take-band').checked;
            /* The same take through the same rig: WAV, MP3 and Play share one
               render instead of running the string physics three times. */
            var key = JSON.stringify(engine.rigState || {}) + '|' + (withBand ? 1 : 0);
            if (rendered && rendered.take === tk && rendered.key === key) return Promise.resolve(rendered.buf);
            rendering = true; takeBusy(true);
            showMsg(T.rendering);
            return engine.render(tk, { withBand: withBand, onProgress: function (f) { showMsg(T.rendering + ' ' + pct(f)); } }).then(function (buf) {
                rendering = false; takeBusy(false); showMsg('');
                rendered = { take: tk, key: key, buf: buf };
                return buf;
            }, function (e) {
                rendering = false; takeBusy(false); showMsg(T.render_failed, 'warn');
                aeErr({ error_type: 'eg_render_failed', err_msg: String(e && e.message || e).slice(0, 160) });
                throw e;
            });
        }
        /* Listen is a play/stop switch that shows which it is: it used to stay
           "▶ Listen" while the take played, and the next press stopped the
           sound the person was waiting to hear. */
        var takeSrc = null;
        function takePlaying(on) {
            var b = $('eg-take-play');
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            $('eg-take-ico').textContent = on ? '■' : '▶';
            $('eg-take-lbl').textContent = on ? T.riff_stop : T.take_play;
        }
        function stopTake() {
            if (!takeSrc) return;
            var s = takeSrc; takeSrc = null;
            try { s.onended = null; s.stop(); } catch (e) {}
            takePlaying(false);
        }
        $('eg-take-play').addEventListener('click', function () {
            if (takeSrc) { stopTake(); return; }
            withAudio(function () {
                renderTake().then(function (buf) {
                    stopTake();
                    var s = engine.ctx.createBufferSource();
                    // through the master: the volume the person set is the volume they hear the take at
                    s.buffer = buf; s.connect(engine.master || engine.ctx.destination); s.start();
                    takeSrc = s; takePlaying(true);
                    s.onended = function () { if (takeSrc === s) { takeSrc = null; takePlaying(false); } };
                    ae('eg_take_play', { preset: st.preset.id });
                }, function () {});
            });
        });
        function fileBase() {
            var d = new Date();
            var pad2 = function (x) { return (x < 10 ? '0' : '') + x; };
            return 'electric-guitar-' + st.preset.id + '-' + d.getFullYear() + pad2(d.getMonth() + 1) + pad2(d.getDate()) + '-' + pad2(d.getHours()) + pad2(d.getMinutes());
        }
        function deliver(blob, name) {
            if (window.__downloadFile) window.__downloadFile(blob, name);
            else { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); }
        }
        /* the site-wide "a result left the page" event, next to the tool's own */
        function complete(fmt, blob) {
            bump(exportsBy, fmt);
            var tk = engine.lastTake;
            try {
                if (window.__aeToolComplete) window.__aeToolComplete({
                    action: 'export', fmt: fmt, preset: st.preset && st.preset.id,
                    durationSec: tk ? Math.round(tk.seconds * 10) / 10 : null,
                    band: $('eg-take-band').checked ? 1 : 0, di: tk && tk.di ? 1 : 0,
                    sizeMB: blob ? Math.round(blob.size / 1048576 * 100) / 100 : null
                });
            } catch (e) {}
        }
        $('eg-dl-wav').addEventListener('click', function () {
            renderTake().then(function (buf) {
                var wav = window.EGEngine.wavBlob(buf, 24);
                deliver(wav, fileBase() + '.wav');
                ae('eg_export', { fmt: 'wav', preset: st.preset.id });
                complete('wav', wav);
            }, function () {});
        });
        $('eg-dl-mp3').addEventListener('click', function () {
            renderTake().then(function (buf) {
                if (!window.MP3Encoder) { var w16 = window.EGEngine.wavBlob(buf, 16); deliver(w16, fileBase() + '.wav'); complete('wav', w16); return; }
                showMsg(T.rendering); takeBusy(true);
                return window.MP3Encoder.encode(buf, { bitrate: CFG.mp3kbps || 320, slug: SLUG,
                    onProgress: function (p) { if (p > 0) showMsg(T.rendering + ' ' + pct(Math.min(1, p > 1 ? p / 100 : p))); } }).then(function (blob) {
                    takeBusy(false); showMsg('');
                    deliver(blob, fileBase() + '.mp3');
                    ae('eg_export', { fmt: 'mp3', preset: st.preset.id });
                    complete('mp3', blob);
                }, function (e) { takeBusy(false); throw e; });
            }).catch(function (e) { if (e && e.message !== 'busy') showMsg(T.render_failed, 'warn'); });
        });
        $('eg-dl-midi').addEventListener('click', function () {
            var tk = engine.lastTake;
            if (!tk) return;
            var bytes = engine.midi(tk);
            if (!bytes) return;
            var mid = new Blob([bytes], { type: 'audio/midi' });
            deliver(mid, fileBase() + '.mid');
            ae('eg_export', { fmt: 'midi', preset: st.preset.id });
            complete('midi', mid);
        });

        // ─────────────────────────── real guitar in ───────────────────────
        var inLoop = null;
        function listInputs() {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return;
            navigator.mediaDevices.enumerateDevices().then(function (ds) {
                var sel = $('eg-in-dev'), cur = engine.input && engine.input.stream.getAudioTracks()[0];
                var curId = cur && cur.getSettings ? cur.getSettings().deviceId : '';
                sel.innerHTML = '';
                ds.filter(function (d) { return d.kind === 'audioinput'; }).forEach(function (d, i) {
                    var o = document.createElement('option'); o.value = d.deviceId; o.textContent = d.label || ('Input ' + (i + 1));
                    if (d.deviceId === curId) o.selected = true;
                    sel.appendChild(o);
                });
            });
        }
        /* The site's microphone manager: it knows WHY an input could not open
           (blocked, no device, held by a DAW or a call, blocked by the OS),
           says so in the page's language, shows the browser's own recovery
           steps and replays this request once access is granted. */
        var mic = null;
        function micManager() {
            if (!mic && window.MicManager) {
                mic = new window.MicManager({
                    locale: window.__LOCALE, slug: SLUG,
                    audioContext: function () { return engine.ctx; },
                    onRetry: function () { openInput($('eg-in-dev').value || null); }
                });
            }
            return mic;
        }
        function openInput(devId) {
            withAudio(function () {
                var m = micManager();
                if (!m || (m.isSupported && !m.isSupported())) { showMsg(T.input_none, 'warn'); return; }
                engine.openInput(devId, function (constraints) { return m.startRaw(constraints); }).then(function (inp) {
                    $('eg-in-live').hidden = false; $('eg-in-close').hidden = false; $('eg-in-open').hidden = true;
                    inp.trim.gain.value = Math.pow(10, (($('eg-in-gain').value - 50) / 50 * 24) / 20);
                    if (inp.gate.parameters) inp.gate.parameters.get('threshold').setValueAtTime(+$('eg-in-gate').value, engine.ctx.currentTime);
                    var bt = /bluetooth|airpods|buds|headset|hands-free|беспровод/i.test(inp.label || '') || (engine.ctx.outputLatency || 0) > 0.08;
                    $('eg-in-lat').textContent = tr('input_latency', { ms: inp.latency || engine.latencyMs() }) + (bt ? ' ' + T.input_bt : '');
                    listInputs();
                    tunerLoop();
                    ae('eg_input', { ok: 1, lat: inp.latency, bt: bt ? 1 : 0 });
                    stats.input++; statDirty = true;
                }, function (e) {
                    // MicManager's error carries the classified cause and its sentence
                    showMsg((e && e.code && e.message) || T.input_failed, 'warn');
                    ae('eg_input', { ok: 0, err: (e && (e.code || e.name)) || 'unknown' });
                });
            });
        }
        $('eg-in-open').addEventListener('click', function () { openInput(); });
        $('eg-in-close').addEventListener('click', function () {
            engine.closeInput(); cancelAnimationFrame(inLoop);
            if (mic) mic.stop();
            $('eg-in-live').hidden = true; $('eg-in-close').hidden = true; $('eg-in-open').hidden = false;
        });
        $('eg-in-dev').addEventListener('change', function () { openInput(this.value); });
        $('eg-in-gain').addEventListener('input', function () { if (engine.input) engine.input.trim.gain.value = Math.pow(10, ((this.value - 50) / 50 * 24) / 20); });
        $('eg-in-gate').addEventListener('input', function () {
            if (engine.input && engine.input.gate.parameters) engine.input.gate.parameters.get('threshold').setValueAtTime(+this.value, engine.ctx.currentTime);
        });
        function tunerLoop() {
            cancelAnimationFrame(inLoop);
            var last = 0;
            (function frame(ts) {
                if (!engine.input) return;
                inLoop = requestAnimationFrame(frame);
                if (ts - last < 60) return;
                last = ts;
                var lv = engine.inputLevel();
                if (!lv) return;
                $('eg-in-meter').style.width = clamp(lv.peak * 100, 0, 100) + '%';
                if (window.PitchDetect && lv.peak > 0.01) {
                    // a bass or a 7-string in a low tuning needs a longer frame
                    // and a lower lag floor than the detector's voice defaults
                    var lowHz = 440 * Math.pow(2, (Math.min.apply(null, tuningArr()) - 69) / 12);
                    var r = lowHz < 60
                        ? window.PitchDetect.detect(lv.buf, lv.sr, { fmin: Math.max(30, lowHz * 0.85) })
                        : window.PitchDetect.detect(lv.buf.subarray(0, 2048), lv.sr);
                    if (r && r.freq && r.clarity > 0.85) {
                        var m = 69 + 12 * Math.log2(r.freq / 440), mr = Math.round(m), cents = Math.round((m - mr) * 100);
                        $('eg-tn-note').textContent = UI.noteName(mr, st.names);
                        $('eg-tn-cents').textContent = (cents > 0 ? '+' : '') + cents + '¢';
                        $('eg-tn-needle').style.left = (50 + cents) + '%';
                    }
                }
            }(0));
        }

        // ───────────────────────────── meter ──────────────────────────────
        function meterLoop() {
            var m = $('eg-meter'), last = 0;
            (function frame(ts) {
                requestAnimationFrame(frame);
                if (document.hidden || ts - last < 80) return;
                last = ts;
                var lv = engine.level();
                var w = Math.round(clamp(Math.sqrt(lv.peak), 0, 1) * 200) / 200;
                if (w === m._w) return;
                m._w = w;
                m.style.transform = 'scaleX(' + w + ')';
            }(0));
        }

        // ───────────────────────────── boot ───────────────────────────────
        var rootEl = $('eg-root');
        $('eg-labels').setAttribute('aria-pressed', st.labels ? 'true' : 'false');
        $('eg-lefty').setAttribute('aria-pressed', st.lefty ? 'true' : 'false');
        [].forEach.call(document.querySelectorAll('[data-kb]'), function (x) { var on = x.dataset.kb === st.kb; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        $('eg-kb-easy').hidden = st.kb !== 'easy'; $('eg-kb-tab').hidden = st.kb !== 'tab';
        /* Keys are read by POSITION (e.code); the help names them as printed on
           a US keyboard. Where the browser can say what THIS keyboard prints
           there, the help uses that: on AZERTY the bottom row starts with W,
           on QWERTZ with Y. Digits stay: every layout prints them on the key. */
        if (navigator.keyboard && navigator.keyboard.getLayoutMap) {
            var US_CODE = { '/': 'Slash', "'": 'Quote', ']': 'BracketRight', '[': 'BracketLeft', ';': 'Semicolon', ',': 'Comma', '.': 'Period', '`': 'Backquote' };
            navigator.keyboard.getLayoutMap().then(function (map) {
                [].forEach.call(document.querySelectorAll('#eg-kb-easy kbd, #eg-kb-tab kbd'), function (k) {
                    var t = k.textContent.trim(), code = /^[A-Z]$/.test(t) ? 'Key' + t : US_CODE[t];
                    var ch = code && map.get(code);
                    // Latin layouts only: Cyrillic, Hangul and Arabic keyboards print
                    // the US legend on the same key anyway
                    if (ch && /^[!-~À-ɏ]$/.test(ch) && ch.toUpperCase() !== t) k.textContent = ch.toUpperCase();
                });
            }, function () {});
        }
        [].forEach.call(document.querySelectorAll('[data-ptype]'), function (x) { var on = x.dataset.ptype === st.padType; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });

        // ─────────────────────────── play mode ────────────────────────────
        /* The instrument over the whole screen, opened by the player like a dialog:
           neck, pads and the hand switches move into a box on <body> and back.
           A phone turned sideways gets the whole width for frets (the site keeps
           its menu open on a landscape phone, which leaves the neck a third
           narrower). Fullscreen where the browser has it (not on iPhone), the
           screen kept awake while it is open, the Back gesture closes it. */
        var stageBox = null, stageHome = [], stageSince = 0, stageSel = null, stageJam = null, stageRec = null;
        function stageSync() {
            if (!stageBox) return;
            stageJam.setAttribute('aria-pressed', jamOn ? 'true' : 'false');
            stageJam.lastChild.textContent = jamOn ? T.jam_stop : T.jam_start;
            stageJam.firstChild.textContent = jamOn ? '\u25A0' : '\u25B6';
            stageJam.setAttribute('aria-label', stageJam.lastChild.textContent);
            var rec = $('eg-rec').getAttribute('aria-pressed') === 'true';
            stageRec.setAttribute('aria-pressed', rec ? 'true' : 'false');
            stageRec.lastChild.textContent = rec ? T.rec_stop : T.rec_start;
            stageRec.firstChild.textContent = rec ? '\u25A0' : '\u25CF';
            stageRec.setAttribute('aria-label', stageRec.lastChild.textContent);
            var rot = stageBox.querySelector('.eg-stage-rot');
            rot.hidden = !(isTouch && window.innerHeight > window.innerWidth);
        }
        function fitStage() {
            if (!stageBox) return;
            stageSync();
            var area = stageBox.querySelector('.eg-stage-neck');
            var bar = $('eg-neckwrap').querySelector('.eg-neckbar');
            neck.set({ fitH: Math.max(150, area.clientHeight - (bar ? bar.offsetHeight : 0) - 2) });
        }
        function stageButton(cls, label, onClick) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = cls;
            b.appendChild(document.createElement('span')).setAttribute('aria-hidden', 'true');
            b.appendChild(document.createElement('span')).textContent = label;
            b.addEventListener('click', onClick);
            return b;
        }
        function enterPlay() {
            if (stageBox) return;
            var box = document.createElement('div');
            box.className = 'eg eg-stage lg-app';
            box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', T.play_mode);
            var bar = document.createElement('div'); bar.className = 'eg-stage-bar';
            stageSel = document.createElement('select'); stageSel.className = 'eg-sel'; stageSel.setAttribute('aria-label', T.genre_title);
            [].forEach.call(genreBtns, function (b) { var o = document.createElement('option'); o.value = b.dataset.genre; o.textContent = b.textContent.trim(); stageSel.appendChild(o); });
            stageSel.value = st.preset.id;
            stageSel.addEventListener('change', function () { applyPreset(stageSel.value); withAudio(function () {}); });
            stageJam = stageButton('tc-btn ghost', T.jam_start, function () { withAudio(function () { setJam(!jamOn); }); });
            stageJam.firstChild.textContent = '\u25B6';
            stageRec = stageButton('tc-btn eg-rec', T.rec_start, function () { $('eg-rec').click(); setTimeout(stageSync, 60); });
            stageRec.firstChild.textContent = '\u25CF';
            var rot = document.createElement('span'); rot.className = 'eg-stage-rot'; rot.textContent = T.rotate_hint;
            stageMsg = document.createElement('p'); stageMsg.className = 'eg-msg'; stageMsg.setAttribute('role', 'status'); stageMsg.hidden = true;
            var pageMsg = $('eg-msg');
            if (!pageMsg.hidden) { stageMsg.textContent = pageMsg.textContent; stageMsg.className = pageMsg.className; stageMsg.hidden = false; }
            var x = document.createElement('button'); x.type = 'button'; x.className = 'eg-stage-x'; x.textContent = '\u00D7';
            x.setAttribute('aria-label', T.play_exit); x.title = T.play_exit;
            x.addEventListener('click', function () { exitPlay(); });
            bar.appendChild(stageSel); bar.appendChild(stageJam); bar.appendChild(stageRec); bar.appendChild(x);
            var area = document.createElement('div'); area.className = 'eg-stage-neck';
            var low = document.createElement('div'); low.className = 'eg-stage-low';
            box.appendChild(bar); box.appendChild(rot); box.appendChild(stageMsg); box.appendChild(area); box.appendChild(low);
            document.body.appendChild(box);
            stageBox = box;
            var moves = [[$('eg-neckwrap'), area], [$('eg-pads'), low], [rootEl.querySelector('.eg-hands'), low]];
            stageHome = moves.map(function (m) { return { el: m[0], parent: m[0].parentNode, next: m[0].nextSibling }; });
            moves.forEach(function (m) { m[1].appendChild(m[0]); });
            document.documentElement.classList.add('eg-noscroll');
            var page = document.querySelector('.layout'); if (page) page.inert = true;
            stageSince = performance.now(); stats.playMode++; statDirty = true;
            // the site's doors: a refused fullscreen is a platform answer, not an error;
            // the screen lock is re-taken after the OS drops it (a bare sentinel is not)
            if (window.__safeFullscreen) window.__safeFullscreen(box);
            if (window.__wakeLock) window.__wakeLock.hold('playmode');
            try { history.pushState({ egPlay: 1 }, ''); } catch (e) {}
            window.addEventListener('resize', fitStage);
            requestAnimationFrame(fitStage);
            try { $('eg-neck').focus({ preventScroll: true }); } catch (e) {}
            ae('eg_playmode', { land: window.innerWidth > window.innerHeight ? 1 : 0, touch: isTouch ? 1 : 0, fs: (box.requestFullscreen || box.webkitRequestFullscreen) ? 1 : 0 });
        }
        function exitPlay(fromHistory) {
            if (!stageBox) return;
            // back in reverse order: an element's old neighbour must be home before it
            for (var i = stageHome.length - 1; i >= 0; i--) { var h = stageHome[i]; h.parent.insertBefore(h.el, h.next); }
            // what play mode was saying stays said on the page
            var pm0 = $('eg-msg');
            if (stageMsg && !stageMsg.hidden) { pm0.textContent = stageMsg.textContent; pm0.className = stageMsg.className; pm0.hidden = false; }
            stageMsg = null;
            stageBox.remove(); stageBox = null; stageSel = null;
            document.documentElement.classList.remove('eg-noscroll');
            var page = document.querySelector('.layout'); if (page) page.inert = false;
            window.removeEventListener('resize', fitStage);
            stats.playModeS += (performance.now() - stageSince) / 1000; stageSince = 0; statDirty = true;
            neck.set({ fitH: null });
            try { if (document.fullscreenElement && document.exitFullscreen) { var xp = document.exitFullscreen(); if (xp && xp.catch) xp.catch(function () {}); } } catch (e) {}
            if (window.__wakeLock) window.__wakeLock.releaseHold('playmode');
            if (!fromHistory) { try { if (history.state && history.state.egPlay) history.back(); } catch (e) {} }
            try { $('eg-play').focus({ preventScroll: true }); } catch (e) {}
        }
        $('eg-play').addEventListener('click', function () { enterPlay(); });
        window.addEventListener('popstate', function () { if (stageBox) exitPlay(true); });

        var qs = new URLSearchParams(location.search);
        var shared = qs.get('tone') ? decodeTone(qs.get('tone')) : null;
        var savedTone = load('tone', null);
        var startId = (shared && shared.p) || load('preset', null) || 'classic-rock';
        if (!P.byId(startId)) startId = 'classic-rock';
        if (shared) {
            applyPreset(startId, { overrides: shared.r, guitar: shared.g, silent: true });
            toast(T.tone_loaded, 'info');
            ae('eg_share_open', { preset: startId });
        } else if (savedTone && savedTone.id === startId && savedTone.rig) {
            applyPreset(startId, { overrides: savedTone.rig, guitar: savedTone.guitar, silent: true });
        } else {
            applyPreset(startId, { silent: true });
        }
        ae('eg_open', { preset: startId, shared: shared ? 1 : 0 });
        window.__EG = { engine: engine, st: st, applyPreset: applyPreset, neck: neck, strumPad: strumPad, pluck: pluck,
            enterPlay: enterPlay, exitPlay: exitPlay, stats: stats, sendSummary: sendSummary };
        document.dispatchEvent(new CustomEvent('eg:ready'));
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
}());
